import { STATUS_FIXED } from "react-stickynode/dist/Sticky";
import * as actionTypes from "../ActionTypes";

const initialState = {
  category: [],
  type: [],
  modalData: [],
  allproducts: [],
  isHasMore: true,
  products: [],
  relatedProducts: [],
  promoproducts: [],
  arrivalproducts: [],
  trendingproducts: [],
  brands: [],
  brandDetail: [],
  filterBrands: [],
  success: false,
  filteredProducts: [],
  FilteredNameProducts: false,
  suggested_subcats: [],
  all_suggested_subcats: [],
  productfetch: true,
  togglesuggestion: false,
  page: 1,
  sort: "",
  min: 0,
  max: 1000,
  priority: 0,
  promotion:false,
  oos: 0,
  brand_id: 0,
  cat_id: 0,
  cat_id_18: 0,
  sub_cat_id: 0,
  sub_cat_18: [],
  country_id: [],
  relatedProduct_page: 1,
  total_relatedProduct_page:  1,
  relatedProduct_limits: 10,
  cat_refs: [],
  togglecats: false,
  suggestionItems:{
    items:[],
    list_brands:[],
    list_categories:[],
    list_subcategories:[]
  },
	diet_id: 0,
	dietary: [],
  suggestion_loading:false
};

export const productReducer = (state = initialState, action) => {
  let isFilter = localStorage.getItem('isfilter');
  switch (action.type) {
    case actionTypes.Product_Category: {
      return {
        ...state,
        category: action.payload,
        cat_refs: action.refs,
        success: action.success,
      };
    }
    case actionTypes.Product_Type: {
      return{
        ...state,
        type: action.payload,
        success: action.success
      }
    }
    case actionTypes.ProductModal: {
      return {
        ...state,
        modalData: action.payload,
      };
    }
    case actionTypes.Products_Mappedwith_SubCat: {
      // !item.store_items_price_types[0].available_quantity
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload]:
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
      };
    }
    case actionTypes.Products_Mappedwith_Cat: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] :
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
      }
    }
    case actionTypes.Products_Mappedwith_Cat_OutOfStock: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] :
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
      }
    }
    case actionTypes.Search_Store_Product: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] :
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
        // togglesuggestion: true
      };
    }
    case actionTypes.Products_Related: {
      return {
        ...state,
        relatedProducts: state.relatedProduct_page > 1 ?
        [...state.relatedProducts, ...action.payload.list] :
          action.payload.list,
        total_relatedProduct_page: action.payload.totalPages
      };
    }
    case actionTypes.Out_Of_Stock: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] :
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
      };
    }
    case actionTypes.Product_Brands: {
      return {
        ...state,
        brands: action.payload,
      };
    }
    case actionTypes.Brand_by_Name: {
      return {
        ...state,
        brandDetail: action.payload,
      };
    }
    case actionTypes.Brand_by_Slug: {
      return {
        ...state,
        brandDetail: action.payload,
      };
    }
    case actionTypes.Product_Filter_Brands: {
      return {
        ...state,
        products: action.payload,
      };
    }
    case actionTypes.Product_Sort_Name: {
      return {
        ...state,
        products: action.payload,
      };
    }
    case actionTypes.Product_Sort_Price: {
      return {
        ...state,
        products: action.payload,
      };
    }
    case actionTypes.Filter_Brands: {
      return {
        ...state,
        filterBrands: action.payload,
        page: action?.payload?.page || 1,
        min: action?.payload?.min,
        max: action?.payload?.max,
        sort: action?.payload?.sort,
        priority: action?.payload?.priority,
        oos: action?.payload?.oos,
        brand_id: action?.payload?.brand_id,
        cat_id:  action?.payload?.cat_id,
        cat_id_18:  action?.payload?.cat_id_18,
        sub_cat_id: action?.payload?.sub_cat_id,
        sub_cat_18: action?.payload?.sub_cat_18,
        country_id: action?.payload?.country_id,
        promotion: action?.payload?.promotion,
	      diet_id: action?.payload?.diet_id,
      };
    }
    case actionTypes.Filtered_Name_Products: {
      return {
        ...state,
        filteredProducts: action.payload,
      };
    }
    case actionTypes.Show_Filtered_Name_Products: {
      return {
        ...state,
        FilteredNameProducts: action.payload,
      };
    }
    case actionTypes.Suggested_SubCat: {
      return {
        ...state,
        suggested_subcats: action.payload.map((item) => {
          return item.sub_cat_name;
        }),
        all_suggested_subcats: action.payload,
      };
    }
    case actionTypes.Promotion_Products: {
      return {
        ...state,
        promoproducts: action.payload
      };
    }
    case actionTypes.Arrival_Products: {
      return {
        ...state,
        arrivalproducts: action.payload
      };
    }
    case actionTypes.Trending_Products: {
      return {
        ...state,
        trendingproducts: action.payload
      };
    }
    case actionTypes.Product_Fetch: {
      return {
        ...state,
        productfetch: action.payload
      }
    }
    case actionTypes.Brand_Products: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] : 
        action.payload,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.payload] :
        action.payload,
        success: action.success,
        isHasMore: action.payload.length > 0
      }
    }
    case actionTypes.Reset_Products: {
      return {
        ...state,
        products: state.allproducts,
        success: action.success,
      }
    }
    case actionTypes.Reset_Suggestions: {
      return {
        ...state,
        all_suggested_subcats: [],
        suggested_subcats: []
      }
    }
    case actionTypes.Toggle_Suggestions: {
      return {
        ...state,
        togglesuggestion: action.payload
      }
    }
    case actionTypes.SUGGESTION_LOADING: {
      return {
        ...state,
        suggestion_loading: action.payload
      }
    }
    case actionTypes.Change_Page:{
      return {
        ...state,
        page: action.payload
      }
    }
    case actionTypes.Reset_Page:{
      return {
        ...state,
        page: 1
      }
    }
    case actionTypes.Reset_Filter_Brands:{
      return {
        ...state,
        page: 1,
        sort: "",
        min: 0,
        max: 1000,
        priority: 0,
        promotion: false,
        oos: 0,
        brand_id: 0,
        cat_id: 0,
        cat_id_18: 0,
        sub_cat_id: 0,
        sub_cat_18: [],
        country_id: [],
	      diet_id: 0,
      }
    }
    case actionTypes.Products_Related_Change_Page:{
      return {
        ...state,
        relatedProduct_page: action.payload
      }
    }
    case actionTypes.Products_Related_Reset_Page:{
      return {
        ...state,
        relatedProduct_page: 1,
        total_relatedProduct_page: 1
      }
    }
    case actionTypes.Toggle_Categories:{
      return {
        ...state,
        togglecats: action.payload
      }
    }
    case actionTypes.SUGGESTION_ITEM:{
      return {
        ...state,
        suggested_subcats: action.list_categories,
        all_suggested_subcats: action.list_subcategories,
        suggestionItems: {
          items:action.items,
          list_brands:action.list_brands,
          list_categories:action.list_categories,
          list_subcategories:action.list_subcategories
        }
      }
    }

    case actionTypes.PRODUCTS_SELECTION: {
      return {
        ...state,
        allproducts: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.allproducts] : 
        action.allproducts,
        products: state.page > 1 && !isFilter ? 
        [...state.allproducts, ...action.allproducts] :
        action.allproducts,
        success: action.success,
        page: action?.page || 1,
        isHasMore : action.allproducts?.length > 0,
      }
    }
    case actionTypes.PRODUCTS_SELECTION_FILTER: {
      return {
        ...state,
        min: action?.payload?.min,
        max: action?.payload?.max,
        sort: action?.payload?.sort,
        priority: action?.payload?.priority,
        oos: action?.payload?.oos,
        brand_id: action?.payload?.brand_id,
        cat_id:  action?.payload?.cat_id,
        sub_cat_id: action?.payload?.sub_cat_id,
        country_id: action?.payload?.country_id,
	      filterBrands: action?.payload,
	      diet_id: action?.payload?.diet_id,
      }
    }
    default: {
      return {
        ...state,
      };
    }
  }
};
